import { ApiError } from '../api.js';

/**
 * What to tell the person when the import's request fails. A refusal from the edge has no words of ours, and "try
 * again" would be wrong for most of them: AWS WAF answers the same file the same way every time. It reads only the
 * first 16 KB of a request's body, so a cell that trips it is near the top of the file (design §16).
 */
export function importFailure(e: unknown, fallback: string): string {
  if (!(e instanceof ApiError)) return fallback;
  if (e.code === 'edge_refused' && e.status === 403) {
    return 'Our security filter stopped this file before it reached Trellistry, so nothing was changed. A cell that looks like code can cause this, such as one containing <script>, onerror= or ../. Please look near the top of the file, or contact Trellistry if you can’t find it.';
  }
  if (e.code === 'edge_refused' && e.status === 413) return 'These files are too large to send together. The limit is 4 MB.';
  if (e.code === 'not_permitted') return 'Your account doesn’t have permission to import. Please ask your church administrator.';
  return e.detail || fallback;
}
